<template>
  <div class="depuracion">
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text">
            Revisión de Documentos
            <router-link :to="{ name: 'Labor', params: { config: config } }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <button @click="cambiarTable('Labores')" :class="tabla == 'Labores' ? 'active' : ''" type="button" class="btn btn-outline-primary">Labores</button>
              <button @click="cambiarTable('Producciones')" :class="tabla == 'Producciones' ? 'active' : ''" type="button" class="btn btn-outline-primary">Producciones</button>
              <button @click="cambiarTable('Entregas')" :class="tabla == 'Entregas' ? 'active' : ''" type="button" class="btn btn-outline-primary">Entregas</button>
            </div>
            <div ref="table" v-if="showtable" :is='tabla' v-bind="$data" @update-touched="updateTouched"></div>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <CButton @click="addLabor()" class="px-4 mx-3 btn-lg" color="success">
              <span>Guardar {{ touched.from }}/{{ touched.to }} </span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title="Reporte"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>
  </div>
</template>

<script>

// import { validationMixin } from "vuelidate";
// import { required } from "vuelidate/lib/validators";

import Labores from './Depuraciones/Labores'
import Producciones from './Depuraciones/Producciones'
import Entregas from './Depuraciones/Entregas'

export default {
  name: 'Depuraciones',
  components: {
    Labores,
    Producciones,
    Entregas
  },
  data() {
    return {
      filter: {},
      ubicaciones: [],
      ubicacionesRaiz: [],
      actividades: [],
      trabajadores: [],
      operadores: [],
      cultivos: [],
      tabla: 'Labores',
      config: this.$route.params.config,
      isLoadingPage: false,
      errores: [],
      showtable: false,
      warningModal: false,
      error: "",
      touched: 0
    };
  },
  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation
    }
  },
  watch: {
    ubicacionRaiz: async function() {
      await this.actualizarInfo()
      console.log('ubicacionRaiz_finaly_actualizarInfo')
      this.$refs.table.actualizarInfo('Depuraciones_ubicacionRaiz_finaly_actualizarInfo')
    }
  },
  created() {
    this.isLoadingPage = true;

    document.addEventListener('wheel', function(){
      if (document.activeElement.type === 'number') document.activeElement.blur();
    })

    this.actualizarInfo()
  },
  methods: {
    cambiarTable(tabla) {
      this.tabla = tabla
    },
    actualizarInfo() {
      console.log('actualizarInfo')
      console.log(this.filter)

      this.isLoadingPage = true;

      if(!this.ubicacionRaiz?.value) {
         this.warningModal = true
         this.error = "Favor de selecionar una ubicación raíz"
         this.isLoadingPage = false;
         return
      }

      const promises = [
        //
        this.$store.dispatch('customHTTP', {
          schema: 'trabajadores',
          'with-trashed': true,
          filter: {
            where: [
              {field: 'payload->ubicaciones', operator: 'regexp', value: `[[:<:]]${this.ubicacionRaiz.value}[[:>:]]` },
              {field: 'payload->suspendido', operator: '!=', value: true }
            ]
          }
        }),
        //
        this.$store.dispatch('customHTTP', {
          schema: 'actividades',
          order: [
            {field: 'payload->ruta', direction: 'asc'}
          ],
        }),
        //
        this.$store.dispatch('customHTTP', {
          schema: 'ubicaciones',
          _filter: {
            where: [{field: 'payload->raiz_id', value: this.ubicacionRaiz.value, operator: '='}],
            orWhere: [{field: 'id', value: this.ubicacionRaiz.value, operator: '='}]
          },
          filter: {
            where: [
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order: [
            {field: 'payload->ruta', direction: 'asc'}
          ]
        }),
        this.$store.dispatch('customHTTP', {
          schema: 'ubicaciones',
          filter: {
            where: [
              {
                field: 'payload->pertenece_id',
                value: 0,
                operator: '='
              },
              {
                field: 'payload->suspendido',
                value: false,
                operator: '='
              }
            ],
          },
          order: [
            {field: 'payload->ruta', direction: 'asc'}
          ]
        }),
        //
        this.$store.dispatch('customHTTP', {
          schema: 'cultivos',
        }),
        //
        this.$store.dispatch('customHTTP', {
          schema: 'operadores',
        })
      ]

      return Promise.all(promises)
      .then(([trabajadores, actividades, ubicaciones, ubicacionesRaiz, cultivos, operadores]) => {
        console.log('actualizarInfo_then')
        this.operadores = operadores.data.map(operador => {
          return {
            id: operador.payload.clave,
            label: operador.payload.clave,
            ...operador.payload
          };
        }).sort((a,b)=>a.label.localeCompare(b.label))
        this.trabajadores = trabajadores.data.map(trabajador => {
          return {
            id: trabajador.id,
            label: trabajador.payload.nombre,
            unidad: trabajador.payload.unidad,
            unidad_extra: trabajador.payload.unidad_extra,
            deleted: trabajador.deleted_at !== null
          };
        }).sort((a,b)=>a.label.localeCompare(b.label))

        this.actividades = actividades.data.map(actividad => {
          return {
            id: actividad.id,
            nombre: actividad.payload.nombre,
            label: actividad.payload.nombre,
            pertenece_id: actividad.payload.pertenece_id,
            tipo_pago: actividad.payload.tipo_pago,
            unidad: actividad.payload.unidad,
            multiplicador_pago: actividad.payload.multiplicador_pago,
            tipo: actividad.payload.tipo,
            ruta: actividad.payload.ruta,
          };
        }).sort((a,b)=>a.label.localeCompare(b.label))

        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return {
            id: ubicacion.id,
            nombre: ubicacion.payload.nombre,
            pertenece_id: ubicacion.payload.pertenece_id,
            cultivo_id: ubicacion.payload.cultivo_id,
            ruta: ubicacion.payload.ruta,
          };
        }).sort((a,b)=>a.nombre.localeCompare(b.nombre))

        this.ubicacionesRaiz = ubicacionesRaiz.data.map(ubicacion => {
          return {
            id: ubicacion.id,
            nombre: ubicacion.payload.nombre,
            label: ubicacion.payload.nombre,
            pertenece_id: ubicacion.payload.pertenece_id,
            cultivo_id: ubicacion.payload.cultivo_id,
            ruta: ubicacion.payload.ruta,
          };
        }).sort((a,b)=>a.nombre.localeCompare(b.nombre))

        this.cultivos = cultivos.data.map(cultivo => {
          return {
            id: cultivo.id,
            label: cultivo.payload.nombre + ' ' + cultivo.payload.variedad,
            embalajes: cultivo.payload.embalajes
          };
        }).sort((a,b)=>a.label.localeCompare(b.label))

      })
      .finally(() => {
        console.log('actualizarInfo_finally')
        this.showtable = true
      })
    },
    addLabor() {
      this.isLoading = true;

      this.$refs.table.recargarDocumentos()
    },
    updateTouched(touched) {
      this.touched = touched
    },
  }
};
</script>
<style>
.depuracion .multiselect__spinner{
  height: 30px;
}
.depuracion .multiselect__placeholder{
  margin-bottom: 0px;
}
.depuracion .multiselect__select{
  height: 34px;
}
.depuracion .multiselect__tags{
    max-height: 35px;
    overflow: auto;
    min-height: unset;
    padding: 5px 40px 5px 5px;
}
</style>
